import { Loader2, Sparkles } from "lucide-react"
import type { FloatingTabPillTab } from "@/components/ui/floating-tab-pill"
import { cn } from "@/lib/utils"

const ASSISTANT_TAB_ICON_CLASS = "h-3.5 w-3.5"

/** Sparkles on every Assistant pill tab; Loader2 while the agent run is streaming. */
export function decorateAssistantTabs(tabs: FloatingTabPillTab[], busy: boolean): FloatingTabPillTab[] {
  return tabs.map((tab) => {
    if (tab.id !== "assistant") return tab
    return {
      ...tab,
      iconWhenCollapsedOnly: tab.iconWhenCollapsedOnly === true,
      icon: busy ? (
        <Loader2 className={cn(ASSISTANT_TAB_ICON_CLASS, "animate-spin")} />
      ) : (
        <Sparkles className={cn(ASSISTANT_TAB_ICON_CLASS, !tab.active && "text-ui-accent")} />
      ),
    }
  })
}
